import React, { Component } from 'react'
import styled from 'styled-components'

import Footer from '../Footer'
import Image from '../Image'

const Section = styled.section`
  height: 50rem;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4rem;
  overflow: hidden;

  @media (max-width: 750px) {
    overflow: visible;
    height: unset;
    padding: 0rem;
    padding-top: 8rem;
    flex-wrap: wrap;
    align-items: unset;
    background-color: #00001a;
  }
`

export const Background = styled.div`
  height: ${({ height }) => height ? height : '100%'};
  width: 100%;
  position: absolute;
  top: ${({ top }) => top ? top : '0'};
  left: 0;

  figure, img {height: 100%; width: 100%; object-fit: cover;}

  @media (max-width: 750px) {
    height: 20rem;

    &::after {
      content: ' ';
      position: absolute;
      bottom: -1%;
      left: 0;
      height: 30%;
      width: 100%;
      z-index: 1;
      pointer-events: none;
      background: linear-gradient(to top, #000018, rgba(0,0,0,0))
    }
  }
`

class SectionEarlyAccess extends Component {
  render() {
    return (
      <Section id='early-access'>
        <Footer windowWidth={this.props.windowWidth} />

        <Background id='footer-background'>
          <Image src='/images/6-early/background.jpg' />
        </Background>
      </Section>
    )
  }
}

export default SectionEarlyAccess
